import { PageTypeGlobal } from "@/lib/types";
import { TicketEventStatus } from "@/openapi/generated";

export type PublicTicketsNavLink = {
  href: string;
  label: "Tickets";
};

/** Navbar link only while at least one event is on sale. */
export function resolvePublicTicketsNavLink(
  events: { status: string }[] | undefined,
): PublicTicketsNavLink | null {
  const onSale = (events ?? []).some(
    (event) => event.status === TicketEventStatus.OnSale,
  );
  if (!onSale) return null;
  return { href: PageTypeGlobal.Tickets, label: "Tickets" };
}
